/**
 * MyEasyGov Platform API (3/8/23)
 * MyEasyGov Platform API.  MyEasyGov's web and mobile app communicates with the MEG platform via this API.
 *
 * OpenAPI spec version: 2.29
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Announcement } from "./announcement";
import { ChargeCardBrands } from "./chargeCardBrands";
import { MegAppFee } from "./megAppFee";
import { PaymentMethods } from "./paymentMethods";
import { PickupLocation } from "./pickupLocation";
import { SearchMethods } from "./searchMethods";

/**
 * this describes the county's configuration data
 */
export interface AgencyDmvConfig {
	agencyID?: string;
	name?: string;
	agencySealFileName?: string;
	taxCollectorName?: string;
	taxCollectorPhotoFileName?: string;
	taxCollectorBio?: string;
	taxCollectorURL?: string;
	taxCollectorEmailAddress?: string;
	taxCollectorPhoneNumber?: string;
	taxCollectorAdditionalInfo?: string;
	taxCollectorMapLink?: string;
	serviceProviderID?: number;
	/**
     * URL of service provider's webcomponent
     */
	providerWebCompURL?: string;
	/**
     * required for Google map.
     */
	mapCenterZipCode?: string;
	allowAddressUpdate?: boolean;
	allowMailingToTempAddress?: boolean;
	allowPickup?: boolean;
	allowManualRegistration?: boolean;
	/**
     * some counties don't support plate change. 
     */
	allowPlateChange?: boolean;
	/**
     * ALWAYS=always charge mail fee, MAILONLY=charge mail fee only if taxpayer has chosen delivery by mail, NEVER=never charge mail fee
     */
	mailFeeModel?: AgencyDmvConfig.MailFeeModelEnum;
	mailFeeAlertText?: string;
	/**
     * some counties don't provide dmv fee breakdown.
     */
	provideDmvFeeDetails?: boolean;
	pickupText?: string;
	termsURL?: string;
	/**
     * if partner does not support pickup, this element will be omitted.
     */
	pickupLocations?: Array<PickupLocation>;
	paymentMethods?: PaymentMethods;
	chargeCardBrands?: ChargeCardBrands;
	providerDonationProductID?: string;
	receiptThankYouText?: string;
	receiptWhatsNextTextMail?: string;
	receiptWhatsNextTextPickup?: string;
	providerFeeName?: string;
	megAppFee?: MegAppFee;
	consolidatedServiceFee?: boolean;
	pageSize?: number;
	primaryColor?: string;
	secondaryColor?: string;
	systemFailureText?: string;
	mapAPIKey?: string;
	paymentTerms?: string;
	paymentDescriptor?: string;
	pickupImageName?: string;
	pickupBranding?: string;
	pickupDescription?: string;
	mapZoomFactor?: number;
	enableUserRegistration?: boolean;
	reusableFundingToken?: boolean;
	licensePlateSearchOption?: number;
	pinSearchOption?: number;
	licensePlateSearchInfoText?: string;
	licensePlateSearchLabel?: string;
	pinSearchLabel?: string;
	homogeneousCart?: boolean;
	businessVehicleHintText?: string;
	searchMethods?: SearchMethods;
	businessRegistrationHintText?: string;
	privacyStatement?: string;
	supportKioskPickup?: boolean;
	pickupPageSubtitleTextKiosk?: string;
	pickupPageSubtitleTextStandard?: string;
	kioskPickupCap?: number;
	kioskPickupLocationID?: number;
	reviewPageKioskPickupText1?: string;
	reviewPageKioskPickupText2?: string;
	reviewPageKioskPickupText3?: string;
	searchNoMatchText?: string;
	addressChangePopupTextPAndT?: string;
	addressChangePopupTextPOnly?: string;
	addressChangePopupTextTOnly?: string;
	addressUpdateCheckboxTextYes?: string;
	addressUpdateCheckboxTextNo?: string;
	undoAddressChangeLinkText?: string;
	permAddressUpdateNote?: string;
	tempAddressChangeNote?: string;
	announcement?: Announcement;
}
export namespace AgencyDmvConfig {
	export type MailFeeModelEnum = "ALWAYS" | "MAILONLY" | "NEVER";
	export const MailFeeModelEnum = {
		ALWAYS: "ALWAYS" as MailFeeModelEnum,
		MAILONLY: "MAILONLY" as MailFeeModelEnum,
		NEVER: "NEVER" as MailFeeModelEnum
	};
}
